 import { mapGetters } from "vuex";
  import { stringHelper } from "@/components/mixins/stringHelper";

  export default {
    name: "MleHarmonizedCodeSummary",
    mixins: [stringHelper],
    props: {
      invoiceDetails: {
        type: Object,
        default: null
      }
    },
    computed: {
      ...mapGetters(["getContentItem", "tenantDetails"]),
      lineItems(){
        return this.invoiceDetails.LineItems;
      },
      hTCs(){
        return [...new Set(this.invoiceDetails.LineItems.map(x => x.HarmonizedTarriffCode))];
      },
      groupItemsByHTC(){
        var groupings = [];
        this.hTCs.forEach(x => {
          var items = this.invoiceDetails.LineItems.filter(item => item.HarmonizedTarriffCode === x);
          groupings[x] = items;
        })
        return groupings;
      }
    },
    methods:{
      getNetWeight(htc){
        var sum = 0;
        this.groupItemsByHTC[htc].map(x => {
          sum += x.NetWeight;
        })
        return this.formatToCommaDecimal(sum);
      },
      getValue(htc) 
      { 
        var sum = 0;
        this.groupItemsByHTC[htc].map(x => {
          sum += x.UnitPrice;
        })
        return this.formatToCommaDecimal(sum);
      },
      getQuantity(htc){
        var sum = 0;
        this.groupItemsByHTC[htc].map(x => {
          sum += x.QuantityShipped;
        })
        return sum;
      }
    },
  };